import { SortDirection } from '@front-app/services/SharedModels';
import { UserRole } from '@front-app/services/UserApi/UserModel';
import { GroupRoleRequest } from '../GroupsApi/GroupsMemberApi';

export interface GroupInvitationCampaign {
	id: string;
	name: string;
	lastModifiedDateTime: string;
	reminderSendHour: number;
	invites: Record<InvitationInviteType, InvitationCampaignInvite>;
}

export interface CreateInvitationCampaignRequest {
	name: string;
	reminderSendHour: number;
	templates: Record<InvitationInviteType, UpsertInvitationCampaignInvite>;
}

export interface UpdateInvitationCampaignRequest {
	name: string;
	reminderSendHour: number;
	initialSendTime: string;
	newRecipients: Array<ExternalInvitee>;
}

export interface ExternalInvitee {
	email: string;
	role: UserRole;
	firstName?: string;
	lastName?: string;
}

export interface InvitationCampaignInvite {
	version: number;
	type: InvitationInviteType;
	lastModifiedDateTime: string;
	subject: string;
	topHtml: string;
	bottomHtml: string;
}

export interface UpsertInvitationCampaignInvite {
	subject: string;
	topHtml: string;
	bottomHtml: string;
}

export enum InvitationInviteType {
	INITIAL = 'initial',
	REMINDER = 'reminder',
}

export interface PublicUserActionOnCampaignInvitation {
	inviteId: string;
	action: GroupRoleRequest.DECLINE;
}

export interface InvitationCampaignInvitee {
	inviteeId: string;
	userId: null | string;
	email: string;
	status: InviteeStatus;
	numTimesNotified: number;
	invitedDateTime: string;
	firstNotificationDateTime: null | string;
	lastNotificationDateTime: string;
}

export enum InviteeStatus {
	ACTIVE = 'active',
	JOINED = 'joined',
	DECLINED = 'declined',
	PAUSED = 'paused',
}

export enum SortParameter {
	EMAIL = 'email',
	STATUS = 'status',
	TIMES_NOTIFIED = 'numTimesNotified',
	INVITED_TIME = 'invitedDateTime',
	LAST_NOTIFICATION_TIME = 'lastNotificationDateTime',
	FIRST_NOTIFICATION_TIME = 'firstNotificationDateTime',
}

export interface FetchInviteesRequestParams {
	search?: string;
	status?: InviteeStatus[];
	orderBy?: SortParameter;
	sortDirection?: SortDirection;
}

export interface InviteeCountsResponse {
	joined: number;
	declined: number;
	active: number;
	paused: number;
}

export interface InviteeCounts {
	all: number;
	joined: number;
	declined: number;
	active: number;
	paused: number;
}

export interface UpdateInviteeStatusesRequest {
	inviteeIds: string[];
	status: string;
}
